import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantGeneralTabService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetMerchantByIdQueryProps = {
	merchantId: string;
};

const useGetMerchantByIdQuery = ({
	merchantId,
}: useGetMerchantByIdQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["getMerchantByIdQuery", merchantId],
		() => merchantGeneralTabService.getMerchant(merchantId),
		{
			select: data => {
				return data;
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!merchantId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetMerchantByIdQuery;
